import { Component, OnInit } from '@angular/core';
import {
  FilterState,
  JobApplication,
  JobApplicationServiceService,
  TabType,
} from './service/job-application-service.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-all-applications',
  standalone: false,
  templateUrl: './all-applications.component.html',
  styleUrls: ['./all-applications.component.css'],
})
export class AllApplicationsComponent implements OnInit {
  currentPage    = 1;
  pageSize       = 10;
  totalElements  = 0;
  totalPagesCount = 0;
dropdownTop  = 0;
dropdownLeft = 0;
  allApplications:      JobApplication[] = [];
  filteredApplications: JobApplication[] = [];

  isLoading     = false;
  errorMessage  = '';

  searchQuery = '';
  searchTimeout: any = null;
  activeTab: TabType = 'all';

  positionTitles: string[] = [];
  statuses = ['SUBMITTED', 'UNDER_REVIEW', 'REVIEWED', 'REJECTED'];

  filters: FilterState = { status: '', positionTitle: '' };
  openDropdown: string | null = null;

  // counts من الـ API مش client-side
  totalCount     = 0;
  submittedCount = 0;
  otherCount     = 0;

  constructor(
    private jobAppService: JobApplicationServiceService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.loadApplications();
  }

loadApplications(): void {
  this.isLoading    = true;
  this.errorMessage = '';
  const page        = this.currentPage - 1;

  // لو فيه search
  if (this.searchQuery.trim()) {
    this.jobAppService.searchApplications(this.searchQuery.trim(), page, this.pageSize).subscribe({
      next: (res) => this.handlePagedResponse(res),
      error: (err) => this.handleError(err),
    });
    return;
  }

  // لو فيه filters
  if (this.filters.status || this.filters.positionTitle) {
    this.jobAppService.filterApplications({
      status:   this.filters.status        || undefined,
      position: this.filters.positionTitle || undefined,
    }, page, this.pageSize).subscribe({
      next: (res) => this.handlePagedResponse(res),
      error: (err) => this.handleError(err),
    });
    return;
  }

  // الـ default — plain array، pagination client-side
  this.jobAppService.getCompanyApplications().subscribe({
    next: (data: JobApplication[]) => {
      this.allApplications      = data;
      this.filteredApplications = data;
      this.totalElements        = data.length;
      this.totalPagesCount      = Math.ceil(data.length / this.pageSize);
      this.positionTitles       = [...new Set(data.map(a => a.positionTitle))].sort();
      this.totalCount           = data.length;
      this.submittedCount       = data.filter(a => a.status === 'SUBMITTED').length;
      this.otherCount           = data.filter(a => a.status !== 'SUBMITTED').length;
      this.isLoading            = false;
    },
    error: (err) => this.handleError(err),
  });
}

toggleDropdown(name: string, event?: Event): void {
  event?.stopPropagation();
  if (event?.target) {
    const rect = (event.target as HTMLElement)
      .closest('button')!
      .getBoundingClientRect();
    this.dropdownTop  = rect.bottom + 6;
    this.dropdownLeft = rect.left;
  }
  this.openDropdown = this.openDropdown === name ? null : name;
}
private handlePagedResponse(res: any): void {
  const pageData            = res.applications;
  this.allApplications      = pageData.content;
  this.filteredApplications = pageData.content;
  this.totalElements        = pageData.totalElements;
  this.totalPagesCount      = pageData.totalPages;
  this.positionTitles       = res.positions ?? [];
  this.totalCount           = pageData.totalElements;
  this.submittedCount       = pageData.content.filter((a: any) => a.status === 'SUBMITTED').length;
  this.otherCount           = pageData.content.filter((a: any) => a.status !== 'SUBMITTED').length;
  this.isLoading            = false;
}

private handleError(err: any): void {
  this.errorMessage = 'Failed to load applications. Please try again.';
  this.isLoading    = false;
  console.error(err);
}

  onSearchChange(): void {
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {
      this.currentPage = 1;
      this.loadApplications();
    }, 400);
  }

  setFilter(filterKey: keyof FilterState, value: string): void {
    this.filters[filterKey] = this.filters[filterKey] === value ? '' : value;
    this.openDropdown       = null;
    this.currentPage        = 1;
    this.loadApplications();
  }

  clearFilter(filterKey: keyof FilterState): void {
    this.filters[filterKey] = '';
    this.currentPage        = 1;
    this.loadApplications();
  }

  setActiveTab(tab: TabType): void {
    this.activeTab = tab;
    // Tab بيأثر على الـ status filter
    if (tab === 'submitted') {
      this.filters.status = 'SUBMITTED';
    } else if (tab === 'other') {
      this.filters.status = '';   // أو ممكن تعمل endpoint تاني لو محتاج
    } else {
      this.filters.status = '';
    }
    this.currentPage = 1;
    this.loadApplications();
  }


  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPagesCount) {
      this.currentPage = page;
      this.loadApplications();
    }
  }

  get totalPages(): number {
    return this.totalPagesCount;
  }

  get paginatedApplications(): JobApplication[] {
    return this.filteredApplications; // الـ API بيرجع الـ page الصح
  }

  get pageNumbers(): number[] {
    const total   = this.totalPages;
    const current = this.currentPage;
    if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
    const pages: number[] = [1];
    if (current > 3) pages.push(-1);
    for (let i = Math.max(2, current - 1); i <= Math.min(total - 1, current + 1); i++) {
      pages.push(i);
    }
    if (current < total - 2) pages.push(-1);
    pages.push(total);
    return pages;
  }

  get hasActiveFilters(): boolean {
    return !!(this.filters.positionTitle || this.filters.status);
  }

  // باقي الـ methods زي ما هي
  getStatusBadgeClass(status: string): string {
    switch (status.toUpperCase()) {
      case 'SUBMITTED':    return 'bg-blue-100 text-blue-700';
      case 'REVIEWED':     return 'bg-green-100 text-green-700';
      case 'UNDER_REVIEW': return 'bg-yellow-100 text-yellow-700';
      case 'REJECTED':     return 'bg-red-100 text-red-700';
      default:             return 'bg-gray-100 text-gray-600';
    }
  }

  getAvatarColor(name: string): string {
    const colors = ['bg-blue-500','bg-purple-500','bg-green-500','bg-rose-500','bg-amber-500','bg-teal-500'];
    return colors[name.charCodeAt(0) % colors.length];
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return '';
    return new Date(dateStr).toLocaleDateString('en-US', {
      year: 'numeric', month: 'short', day: 'numeric',
    });
  }

  goToDetails(id: string): void {
    this.router.navigate(['company-admin', 'application', id]);
  }
}
